import { isNil, omitBy } from 'lodash'

import { api } from '@marketplace-web/core-api/core-api-client-data'

import { FeedbackListResp, GetUserFeedbackArgs } from '../types/user-feedback'

export const getUserFeedback = ({
  userId,
  filter,
  page,
  perPage,
  feedbackFilterType,
}: GetUserFeedbackArgs) =>
  api.get<FeedbackListResp>('/user_feedbacks', {
    params: omitBy(
      {
        user_id: userId,
        filter,
        page,
        per_page: perPage,
        by: feedbackFilterType,
      },
      isNil,
    ),
  })
